<template>
  <div class="self-news">
    <div class="inner">
      <div class="con">
        <div class="g-box con-in">
          <div class="title">
            <div class="zh">{{ dataInfo.name }}</div>
            <div class="en">{{ dataInfo.tips }}</div>
          </div>
          <div class="imgs">
            <div
              class="news"
              :style="{
                backgroundImage: 'url(' + item.image + ')'
              }"
              v-for="item in dataList"
              @click="toDetail(item)"
              :key="item.id"
            >
              <div class="new-in">
                <div class="tit">{{ item.title }}</div>
                <div class="intro">
                  {{ item.subtitle }}
                </div>
                <div class="time">{{ item.publishTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more">
      <div class="more-in" @click="toMore">
        <span class="txt">更多资讯</span><span class="line"></span>
        <div class="orcal"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 2,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
  },
  methods: {
    toMore() {
      this.toMenu(this.pageType, this.menuId);
    },
    toDetail(item) {
      this.$router.push("/article_details/" + item.id);
    }
  }
};
</script>
<style lang="less">
.self-news {
  padding-bottom: 120px;
  padding-left: 11.5%;
  background: #2c6fff;
  box-sizing: border-box;
  .inner {
    padding-left: 40px;
    display: flex;
    align-items: flex-end;
    height: 410px;
    background: #eee;
    border-radius: 0 0 0 24px;
    box-sizing: border-box;
    .con {
      display: flex;
      align-items: center;
      .title {
        padding-right: 40px;
        .zh {
          font-size: 48px;
          font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
          font-weight: 800;
          color: #000;
          line-height: 70px;
        }
        .en {
          font-size: 72px;
          font-family: "en-tit";
          color: #000;
          line-height: 87px;
          text-transform: uppercase;
        }
      }
      &-in {
        display: flex;
      }
    }
    .imgs {
      display: flex;
      align-items: center;
      .news {
        position: relative;
        margin-right: 60px;
        width: 380px;
        height: 310px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 24px;
        cursor: pointer;
        .new-in {
          position: absolute;
          bottom: -132px;
          width: 100%;
          .tit {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #fff;
            line-height: 28px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .intro {
            padding-top: 12px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            line-height: 26px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .time {
            padding-top: 18px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            line-height: 16px;
          }
        }
      }
      .news:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
  .more {
    padding-top: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    .more-in {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .txt {
      margin-right: 16px;
    }
    .line {
      margin-right: -35px;
      width: 50px;
      height: 1px;
      background-color: #fff;
    }
    .orcal {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 10px solid #fff;
    }
  }
}
</style>
